import Categories from 'src/views/Pages/Dashboard/Assistance/Category/Index.vue';
import EditCreate from 'src/views/Pages/Dashboard/Assistance/Category/EditCreate.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Status from 'src/views/Pages/Dashboard/Assistance/Status/Index.vue';
import Types from 'src/views/Pages/Dashboard/Assistance/Type/Index.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const AssistanceRoutes = {
  path: 'assistance',
  component: MasterTab,
  props: { reference: 'assistanceTabs' },
  children: [
    {
      path: 'statuses',
      name: 'Estados',
      component: Status,
      meta: {
        prefix_permission: 'assistance_statuses',
      },
    },
    {
      path: 'categories',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Categorías',
          component: Categories,
          meta: {
            prefix_permission: 'assistance_categories',
          },
        },
        {
          path: 'create',
          name: 'Categorías',
          component: EditCreate,
          meta: {
            prefix_permission: 'assistance_categories',
          },
        },
        {
          path: 'edit',
          name: 'Categorías',
          component: EditCreate,
          meta: {
            prefix_permission: 'assistance_categories',
          },
        },
      ],
    },
    {
      path: 'types',
      name: 'Tipos',
      component: Types,
      meta: {
        prefix_permission: 'assistance_types',
      },
    },
  ],
};

export default AssistanceRoutes;
